import Select from "react-select";
import { useEffect } from "react";

export const InputSelect = props => {
  const { arr = [], id, formik, label = "xxx", mayuscula = false, llave_texto = "nombre", llave_valor = "id", ejecute, disabled = false, clases = "", value = "" } = props;
  const arrOpts = (t, texto, valor) => t.map(el => ({ label: el[texto], value: valor ? el[valor] : el }));

  return (
    <>
      {label !== "xxx" && <label htmlFor={id}>{label}</label>}
      <Select
        isDisabled={disabled}
        texto=""
        name={id}
        id={id}
        className={`selectDos ${clases}`}
        onChange={e => {
          formik ? formik.setValues({ ...formik.values, [id]: e ? e.value : "" }) : ejecute(e);
        }}
        placeholder="---Seleccione---"
        // defaultValue={"cuestioooon"}
        // value={"cuestiooooon"}
        isClearable={true}
        classNamePrefix={"limpiarSelect"}
        options={arrOpts(arr, llave_texto, llave_valor)}
      />
    </>
  );
};

document.querySelector("#formSearchAdmin > div > div:nth-child(1) > div:nth-child(1) > div > div > div.limpiarSelect__indicators.css-1hb7zxy-IndicatorsContainer > div.limpiarSelect__indicator.limpiarSelect__clear-indicator.css-1xc3v61-indicatorContainer");
